import React from "react";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";

// `isPartner` intentionally has no default — when the caller doesn't
// specify, AppHeader and AppSidebar each self-detect via the Apollo
// cache (`currentUser.coach_profile.is_partner`). Defaulting to `false`
// here would short-circuit that detection and force partners into the
// owner shell.
export default function AppLayout({
  children,
  breadcrumb = "DASHBOARD",
  persona,
  userName,
  userInitials,
  hasNotifications = true,
  isPartner,
  planProgress = { completed: 2, total: 5, percentage: 40 },
  actionPlanBadge = 3,
}) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'hsl(var(--page-bg))' }}>
      <AppHeader
        breadcrumb={breadcrumb}
        persona={persona}
        userName={userName}
        userInitials={userInitials}
        hasNotifications={hasNotifications}
      />

      <AppSidebar
        persona={persona}
        isPartner={isPartner}
        planProgress={planProgress}
        actionPlanBadge={actionPlanBadge}
      />

      <main className="pt-14 md:ml-[240px]">{children}</main>
    </div>
  );
}
